import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/table";
import { TailSpin } from "react-loader-spinner";
import { Modal } from "antd";
import Icon from "../../../assets/icons";
import { format } from "date-fns";

const RestrictionsTable = ({
  data,
  selectedStatus,
  handleStatusChange,
}: any) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const columns = [
    {
      header: "Account Name",
      accessor: "accountName",
      render: (data: any) => (
        <p className="text-sm capitalize">{data?.user?.fullname}</p>
      ),
    },
    {
      header: "Amount",
      accessor: "amount",
      render: (data: any) => <p className="text-sm">₦{data?.amount}</p>,
    },
    { header: "Status", accessor: "status" },
    {
      header: "Date",
      accessor: "created_at",
      render: (data: any) => <p className="text-sm">{data?.created_at}</p>,
    },
    {
      header: "Action",
      accessor: "action",
      render: (data: any) => (
        <button
          className="text-sm  text-[#0979A1] cursor-pointer"
          onClick={() => {
            setSelectedData(data);
            setShowModal(true);
          }}
        >
          View
        </button>
      ),
    },
  ];

  useEffect(() => {
    const filtered = data?.filter((request: any) => {
      if (request.status) {
        return true;
      }
      return false;
    });
    setFilteredData(filtered);
    setIsLoading(false);
  }, [data, selectedStatus]);

  const handleUserClick = (id: string) => {
    navigate(`/request/${id}`);
  };

  const mappedData = filteredData.map((request: any) => ({
    ...request,
    fullName: request?.assignedTo?.fullname || "N/A",
  }));

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All Restrictions</p>
        <div className="flex gap-2">
          <span className="text-[14px] font-medium">Filter by:</span>
          <select
            className="border text-[12px] px-3 py-1 rounded bg-[#0979A1] text-white"
            value={selectedStatus}
            onChange={handleStatusChange}
          >
            <option value="">All</option>
            <option value="resolved">Resolved</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
          </select>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : filteredData.length > 0 ? (
        <Table
          columns={columns}
          data={mappedData}
          selectedUserId={null}
          onUserClick={() => {}}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}
      {showModal && (
        <RestrictionModal
          showModal={showModal}
          setShowModal={setShowModal}
          data={selectedData}
        />
      )}
    </div>
  );
};

export default RestrictionsTable;

const RestrictionModal = ({ showModal, setShowModal, data }: any) => {
  return (
    <Modal
      open={showModal}
      onCancel={() => setShowModal(false)}
      centered
      width={470}
      footer={null}
      style={{
        padding: "0px",
      }}
      className=""
    >
      <div className="flex flex-col gap-4 !p-0">
        <div className="flex justify-between">
          <p className="text-xs font-semibold"> Details</p>
          <button onClick={() => setShowModal(false)}>
            <Icon name="cancel" />
          </button>
        </div>
        <div className="border-t py-4 flex flex-col gap-2 ">
          <div className="flex items-center justify-between gap-2">
            <p className="text-xs text-gray-500 font-medium">
              Amount restricted{" "}
              {data?.type === "partial"
                ? "(Partial restriction)"
                : "(Full restriction)"}
            </p>
            <p className="text-xs">
              {format(new Date(data?.created_at), "MMMM d, yyyy h:mm a")}
            </p>
          </div>
          <p className="text-base font-medium">₦{data?.amount}</p>
          <div className="border p-4 rounded-2xl text-xs flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <p className="font-medium">Admin:</p>
              <p className="text-gray-500 font-medium">
                {data?.admin?.fullname}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <p className="font-medium">Reason: </p>
              <p className="text-gray-500 font-medium">{data?.reason}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
